export enum PaidServiceStageIds {
  'DEFINITION' = 10,
  'CALCULATE_NEED' = 20,
  'CALCULATE_PREPARATION' = 30,
  'CALCULATE_CHECK' = 40,
  'CHECK' = 50,
  'WAITING_PAYMENT' = 55,
  'COMPLETING_WORK' = 60,
  'CORRECT_CALCULATION_PREPARATION' = 70,
  'CORRECT_CALCULATION_CHECK' = 80,
  'ADDITIONAL_CHECK' = 90,
  'UPD' = 100,
  'DRAFTING_CONTRACT_FOR_SPECIFYING_SERVICES' = 200,
  'GET_SCAN_OF_SIGNED_CONTRACT' = 210
}
